import * as React from 'react'
import CloudSyncIcon from '@mui/icons-material/CloudSync'
// ICONS
import CompassCalibrationIcon from '@mui/icons-material/CompassCalibration'
import DeleteIcon from '@mui/icons-material/Delete';
// TO DO: remove when not needed
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import SimCardIcon from '@mui/icons-material/SimCard'
// MUI components
import { Box } from '@mui/material'
import Button from '@mui/material/Button'
import Fade from '@mui/material/Fade'
import Menu from '@mui/material/Menu'
import { MenuProps } from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { alpha, styled } from '@mui/material/styles'
import { useUnleashClient } from '@unleash/proxy-client-react'
import FaberFeatureToggle from 'common/FaberComponents/FaberFeatureToggle'

export const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0'
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5)
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        )
      }
    }
  }
}))

export default function ExternalActionMenuForOneUser({
  productType,
  handleEsimRequestDialogV2Open,
  handleRefreshNetworkDialogOpen,
  showRefreshNetworkButton,
  handleSwitchWhitelistDialogOpen,
  handleDeletePaymentMethodDialogOpen,
}: ActionProps) {
  const unleash = useUnleashClient()
  const isEsimRequestOTPEnabled = unleash.isEnabled('replace-esim-otp')

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const isOtp: boolean = productType === 'otp'

  return (
    <>
      <Box>
        <Button
          variant='contained'
          id='fade-button'
          aria-controls={open ? 'fade-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          sx={{ fontSize: '12px', padding: '4px 12px' }}
          endIcon={<KeyboardArrowDownIcon />}
        >
          Actions
        </Button>
        <StyledMenu
          id='fade-menu'
          MenuListProps={{
            'aria-labelledby': 'fade-button'
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          {showRefreshNetworkButton && (
            <FaberFeatureToggle
              activeComponent={
                <MenuItem
                  sx={{ fontSize: '12px' }}
                  onClick={handleRefreshNetworkDialogOpen}
                >
                  <CloudSyncIcon />
                  Refresh network
                </MenuItem>
              }
              inactiveComponent={<></>}
              feature='refresh-network'
            />
          )}
          {isOtp && (
            <MenuItem
              onClick={() => {
                handleSwitchWhitelistDialogOpen &&
                  handleSwitchWhitelistDialogOpen()
              }}
              sx={{ fontSize: '12px' }}
            >
              <CompassCalibrationIcon />
              Switch whitelist
            </MenuItem>
          )}

          {!isOtp || (isOtp && isEsimRequestOTPEnabled) ? (
            <MenuItem
              onClick={() => handleEsimRequestDialogV2Open()}
              sx={{ fontSize: '12px' }}
            >
              <SimCardIcon />
              eSIM replacement /
              <br />
              Resend eSIM activation email
            </MenuItem>
          ) : null}

          {/* Delete user's payment method from stripe */}
          {isOtp && (
            <MenuItem
              sx={{ fontSize: '12px' }}
              onClick={handleDeletePaymentMethodDialogOpen}
            >
              <DeleteIcon />
              Delete payment method
            </MenuItem>
          )}
        </StyledMenu>
      </Box>
    </>
  )
}

interface ActionProps {
  handleEsimRequestDialogOpen: (event: string) => void
  handleEsimRequestDialogV2Open: () => void
  handleSuspendOrUnsuspendDialogOpen: () => void
  handleUserPlanDialogOpen: () => void
  handleUserEditDetailsDialogOpen: () => void
  handleWinbackDialogOpen: () => void
  handleCancelSubDialogOpen: () => void
  handleRefreshNetworkDialogOpen: () => void
  showRefreshNetworkButton: boolean
  productType?: string
  userId: string
  handleSwitchWhitelistDialogOpen?: () => void
  handleDeletePaymentMethodDialogOpen: () => void
}
